import React from "react"
import PropTypes from "prop-types"

import LoaderSection from '../app_components/LoaderSection'
import StandardButton from '../app_components/StandardButton'
import SentConnectRequests from './SentConnectRequests'
import ConnectRequests from './ConnectRequests'
import Connects from './Connects'
import SendConnectRequest from './SendConnectRequest'
import MissedConnects from './MissedConnects'

class ConnectDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentUser: [],
      connectedUsers: [],
      requestedConnects: [],
      dataLoaded: false,
      windowWidth: 0,
      requestOpen: false,
      requestee_name: '',
      requestee_id: '',
      og_connection: false,
      ogConnectionsSent: [],
      sentConnectRequests: [],
      missedConnects: []
    }

    this.handleResize = this.handleResize.bind(this)
    this.closeRequest = this.closeRequest.bind(this)
    this.openRequest = this.openRequest.bind(this)
    this.updateOgConnectionNames = this.updateOgConnectionNames.bind(this)
  }

  handleResize() {
    this.setState({windowWidth: window.innerWidth})
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);

    $.ajax({
      url: `../getSentConnectData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          sentConnectRequests: JSON.parse(data.data.sent_requests),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  closeRequest() {
    this.setState({
      requestOpen: false,
      requestee_name: '',
      requestee_id: '',
      og_connection: false
    })
  }

  openRequest(name, id, og_connection) {
    window.scrollTo(0, 0)
    this.setState({
      requestOpen: true,
      requestee_name: name,
      requestee_id: id,
      og_connection: og_connection
    })
  }

  componentWillMount() {

    this.handleResize()
    $.ajax({
      url: `../getUserConnectData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          currentUser: JSON.parse(data.data.current_user),
          connectedUsers: JSON.parse(data.data.connected_users),
          requestedConnects: JSON.parse(data.data.requested_connects),
          missedConnects: JSON.parse(data.data.missed_connects),
          dataLoaded: true,
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateOgConnectionNames(name) {
    this.setState({
      ogConnectionsSent: [...this.state.ogConnectionsSent, name]
    })
  }

  render() {
    if(!this.state.dataLoaded) {
      return(<LoaderSection/>)
    }
    if(this.state.dataLoaded) {
      return(
        <div className="profileContainer" style={{maxWidth: 450, margin: 'auto', marginTop: 24, padding: 5}}>
          {this.state.requestOpen &&
            <SendConnectRequest
              requestee_id={this.state.requestee_id}
              requestee_name={this.state.requestee_name}
              closeRequest={this.closeRequest}
              openRequest={this.openRequest}
              og_connection={this.state.og_connection}
              updateOgConnectionNames={this.updateOgConnectionNames}
              />}
          <div>
            {(this.state.connectedUsers.length > 0) &&
              <div >
              <h4 className="sectionHeader">{this.props.connectedUsers != [] ? `${this.state.connectedUsers.length}` : 'My'} Connect{this.state.connectedUsers.length === 1 ? "" : "s"}</h4>
              <Connects
                missingImg={this.props.missingImg}
                currentUserId={this.state.currentUser.id}
                connectedUsers={this.state.connectedUsers}
                acceptRequestIcon={this.props.acceptRequest}
                /></div>}
              {(this.state.connectedUsers.length === 0) &&
                <div style={{marginBottom: 50}}>
                  <h4 className="sectionHeader">My Connects</h4>
                  <h4 className="sectionText" style={{marginBottom: 20, marginTop: 10}} >You don't have any <span style={{fontWeight: 700}}>Connects</span> yet! Click below to start making friends.</h4>
                  <div className="friendsIllustration" onClick={() => window.location.assign('/friends')}></div>
                </div>
              }
            <div style={{textAlign: 'center', marginBottom: 20}}>
              <StandardButton text="Find New Connects" size="large" primary={true} onClick={() => window.location.assign('/friends')} />
            </div>
          </div>



          {this.state.requestedConnects.length > 0 &&
            <ConnectRequests
              requestedConnects={this.state.requestedConnects}
              acceptRequestIcon={this.props.acceptRequest}
              declineRequestIcon={this.props.declineRequest}
           />}
           {this.state.sentConnectRequests.length > 0 &&
             <SentConnectRequests
               missingImg={this.props.missingImg}
               requestedConnects={this.state.sentConnectRequests}
            />}
           {this.state.missedConnects.length > 0 &&
             <MissedConnects
               missingImg={this.props.missingImg}
               missedConnects={this.state.missedConnects}
             />
           }


        </div>
      )
    }
    return <LoaderSection/>
  }
}

export default ConnectDashboard;

// <OgConnection
//   missingImg={this.props.missingImg}
//   openRequest={this.openRequest}
//   ogConnectionsSent={this.state.ogConnectionsSent}
//   currentUserId={this.state.currentUser.id}
// />
